module.exports = __webpack_public_path__ + "static/media/3-.730f3108.webp";